import { useEffect, useState } from 'react';
import { YMInitializer } from 'react-yandex-metrika';

const METRIKA_ID = 91985458;
const COOKIE_NAME_STRING = 'cookiesAccepted=';
const COOKIES_ACCEPTED_EVENT = 'cookiesAccepted';

function hasConsentCookie() {
	return document.cookie
		.split(';')
		.map(cookie => cookie.trim())
		.some(cookie => cookie.startsWith(COOKIE_NAME_STRING));
}

function isMetrikaScriptAlreadyOnPage() {
	return Array.from(document.scripts).some(script =>
		script.src.includes('https://mc.yandex.ru/metrika/tag.js')
	);
}

function YandexMetrika() {
	const [enabled, setEnabled] = useState<boolean>(() => hasConsentCookie());

	useEffect(() => {
		const onCookiesAccepted = () => setEnabled(true);

		window.addEventListener(COOKIES_ACCEPTED_EVENT, onCookiesAccepted);

		if (hasConsentCookie()) {
			setEnabled(true);
		}

		return () => {
			window.removeEventListener(COOKIES_ACCEPTED_EVENT, onCookiesAccepted);
		};
	}, [enabled]);

	const shouldRenderMetrika = enabled && !isMetrikaScriptAlreadyOnPage();

	if (!shouldRenderMetrika) return null;

	return (
		<YMInitializer
			accounts={[METRIKA_ID]}
			options={{
				webvisor: true,
				clickmap: true,
				trackLinks: true,
				accurateTrackBounce: true
			}}
		/>
	);
}

export default YandexMetrika;
